import { observer } from 'mobx-react';
import React from 'react';
import { Link, PromiseMessage, PromiseRetry } from '../../../lib/components';
import { dateFormat, ReactNodeGenerator, Disposers } from '../../../lib/helpers';
import { routes } from '../../../pages/Routes';
import { ClassroomStatus, ClassroomStatusLabels } from '../../classroom/models/classroom-models';
import { TeacherScheduleStore } from './TeacherScheduleStore';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import $ from 'jquery';
import { httpClient } from 'domain/utils/httpClient';
import { environment } from 'lib/environment';
import Swal from 'sweetalert2';
import { reaction } from 'mobx';
import moment from 'moment';
import { userStatusService } from 'domain/index'
import {
  HttpPromiseState} from 'lib/helpers';
import { TeacherScheduleClassroomResponse } from 'domain/models/response-model';
import { Helmet, HelmetTags } from "react-helmet";
import { routerStore } from "lib/components/router/routerStore";
import { TeacherEditLessonModal, TeacherEditLessonModal_Data } from "lib/components/TeacherEditLessonModal";
import swal from 'sweetalert2';
import q from 'q';
import { ClassroomDetailDto } from './models/teacher-models';

const gStore = new TeacherScheduleStore();

const SCHEDULER_ID: string = 'TeacherSchedulerKendoUI';

class TeacherSchedulerKendoUI extends React.Component<{
  classroomScheduleHttpState: HttpPromiseState<TeacherScheduleClassroomResponse>;
}> {

  timezone: string = 'Etc/UTC';

  countdownIntervalId: number | undefined = undefined;

  idleIntervalId: number | undefined = undefined;
  idleTime: number = 0;

  componentWillUnmount() {
    var scheduler = $("#" + SCHEDULER_ID).data("kendoScheduler");
    if (scheduler) {
      scheduler.destroy();
    }
    if (this.countdownIntervalId) {
      window.clearInterval(this.countdownIntervalId);
    }
    if (this.idleIntervalId) {
      window.clearInterval(this.idleIntervalId);
    }
  }

  componentDidMount() {
    var self = this;
    var timezones = userStatusService.status.user?.TimeZone?.Name.split('/');
    var timezoneValue = userStatusService.status.user?.TimeZone?.Name;

    if (timezones && timezones.length > 2) {
      var [first, second] = timezones;
      timezoneValue = `${first}/${second}`;
    }
    // var timezoneName = timezones.length > 2 ? timezones.shift().join('/') : ;
    this.timezone = timezoneValue ?? 'Etc/UTC';
    this.countdownIntervalId = window.setInterval(this.updateStartButtons, 1000);
    this.idleIntervalId = window.setInterval(() => {
      self.idleTime += 1;
      if (self.idleTime > 4) { // 5 minutes
        window.location.reload();
      }
    }, 60000);
    $(window.document).on('mousemove', function () {
      self.idleTime = 0;
    });
    $(window.document).on('keypress', function () {
      self.idleTime = 0;
    });

    // Fix for bug when teacher in class room and click back button in Browser
    window.addEventListener('popstate', () => {
      window.location.reload();
    });
  }

  setupKendoScheduler = (newState: any, addedTags: HelmetTags, removedTags: HelmetTags) => {

    $("#" + SCHEDULER_ID).kendoScheduler({
      add: (e) => {
        e.preventDefault();
      },
      edit: (e) => {
        e.preventDefault();
      },
      move: (e) => {
        e.preventDefault();
      },
      remove: (e) => {
        e.preventDefault();
      },
      resize: (e) => {
        e.preventDefault();
      },
      moveStart: (e) => {
        e.preventDefault();
      },
      resizeStart: (e) => {
        e.preventDefault();
      },
      allDaySlot: false,
      currentTimeMarker: false,
      footer: false,
      date: gStore.serverTime.nowMoment.toDate(),
      height: 600,
      views: [
        {
          type: "agenda",
          selected: true,
          eventTemplate: $("#classroom-template-agenda").html(),
          eventTimeTemplate: $("#event-time-template").html(),
        },
        { type: "day" },
        { type: "week" },
        { type: "month" }
      ],
      editable: {
        destroy: false
      }
    });
    if (this.props.classroomScheduleHttpState.isResolved) {
      this.updateDataSource();
    }
    reaction(() => this.props.classroomScheduleHttpState.value, () => {
      this.updateDataSource();
    });

    $("#" + SCHEDULER_ID).on('click', '.btn-action-marker', (evt) => {
      const $btn = $(evt.target);
      const action: string = $btn.data('action');
      const classroomId: number = $btn.data('classroomid');
      switch (action) {
        case "Start":
          this.btnActionStart(classroomId);
          break;
        case "SuggestTime":
          this.btnActionSuggestTime(classroomId);
          break;
        case "ApproveTime":
          this.btnActionApproveTime(classroomId);
          break;
        case "EditLesson":
          const studentLevelId: number = $btn.data('studentlevelid');
          const unitId: number = $btn.data('unitid');
          const lessonId: number = $btn.data('lessonid');
          this.btnActionEditLesson(classroomId, studentLevelId, unitId, lessonId);
          break;
        case "Finish":
          this.btnActionFinish(classroomId);
          break;
        case "DeclineTime":
          this.btnActionDeclineTime(classroomId);
          break;
        case "DeclineAndSuggestTime":
          this.btnActionDeclineAndSuggestTime(classroomId);
          break;
        case "Preview":
          this.btnActionPreviewLesson(classroomId);
          break;
      }
    });
  }

  btnActionStart = (classroomId: number) => {
    routerStore.navigateTo(routes.teacherClassroom(classroomId));
  }

  async btnActionDeclineTime(classRoomId: number) {
    let url = `${environment.apiServer}/administrator/classroom-decline-time`;
    const request: ClassroomAcceptTimeRequest = {
      ClassRoomId: classRoomId
    }
    await httpClient.axios.postWithSweetAlert<any>(url, request);
    Swal.fire({ icon: 'success' });
    gStore.load();
  }

  btnActionDeclineAndSuggestTime = (classroomId: number) => {
    if (gStore.scheduledClassrooms === null) {
      return;
    }
    const found = gStore.scheduledClassrooms.find((x) => x.ClassRoomId === classroomId);
    if (!found) {
      return;
    }
    gStore.declinedAndSuggestedClassRoom = found;
  }

  async btnActionFinish(classroomId: number) {
    const resp = await httpClient.axios.getWithSweetAlert<ClassroomDetailDto>(
      `${environment.apiServer}/teacher/classroom-detail/${classroomId}`
    );
    const data = resp.data;

    const now = moment.utc();
    const start = moment.utc(data.ScheduledStartTime);

    if (now.diff(start, 'minutes') < 15) {
      await Swal.fire({
        icon: 'warning',
        text: 'Cannot finish lesson before 15 minutes from scheduled start.'
      });
      return;
    }

    if (!data.StudentFirstSeen) {
      await Swal.fire({
        icon: 'warning',
        text: 'The student was absent from the lesson. If the absence is unexcused, only half of the lesson will be counted for you.'
      });
    }

    await httpClient.axios.postWithSweetAlert<any>(
      `${environment.apiServer}/teacher/classroom-finish`,
      { ClassRoomId: classroomId }
    );

    Swal.fire({ icon: 'success' });
    gStore.load();
  }

  btnActionSuggestTime = (classroomId: number) => {
    if (gStore.scheduledClassrooms === null) {
      return;
    }
    const found = this.props.classroomScheduleHttpState.value?.Events.find((x) => x.ClassRoomId === classroomId);
    if (!found) {
      return;
    }
    gStore.suggestedClassRoom = found;
  }

  btnActionApproveTime = (classroomId: number) => {
    if (gStore.scheduledClassrooms === null) {
      return;
    }
    const found = gStore.scheduledClassrooms.find((x) => x.ClassRoomId === classroomId);
    if (!found) {
      return;
    }
    gStore.acceptClassRoom = found;
  }

  btnActionEditLesson = (classroomId: number, studentLevelId: number, unitId: number, lessonId: number) => {
    const msgData: TeacherEditLessonModal_Data = {
      classroomId,
      studentLevelId,
      unitId,
      lessonId
    };
    PubSub.publish("TeacherEditLessonModal_Open", msgData);
  }

  btnActionPreviewLesson = (classroomId: number) => {
    const url = routes.teacherClassroom(classroomId);
    routerStore.navigateTo(url + "?preview");
  }

  private async updateDataSource() {
    var self = this;
    if (this.props.classroomScheduleHttpState.isResolved === false) {
      return;
    }

    const scheduleData = this.props.classroomScheduleHttpState.value;
    var scheduler = $("#" + SCHEDULER_ID).data("kendoScheduler");
    const dsOptions = {
      data: scheduleData,
      schema: {
        data: "Events",
        model: {
          id: "taskId",
          fields: {
            taskId: { from: "ClassRoomId", type: "number" },
            title: { from: "Title", defaultValue: "No title", validation: { required: true } },
            start: { type: "date", from: "StartDate" },
            end: { type: "date", from: "EndDate" },
            endUser: { type: "date", from: "EndDateUser" },
            startTimezone: { from: "StartTimezone" },
            endTimezone: { from: "EndTimezone" },
            teacherId: { from: "TeacherId" },
            teacherName: { from: "TeacherName" },
            studentId: { from: "StudentId" },
            studentName: { from: "StudentName" },
            studentLevelId: { from: "StudentLevelId" },
            status: { from: "Status" },
            suggestionStartTime: { from: "SuggestionStartTime" },
            suggestionUserId: { from: "SuggestionUserId" },
            suggestionStartTimeFormatted: { from: "SuggestionStartTimeFormatted" },
            showSuggestButton_Computed: { from: "ShowSuggestButton_Computed" },
            showApproveButton_Computed: { from: "ShowApproveButton_Computed" },
            showStartButton_Computed: { from: "ShowStartButton_Computed" },
            showEditLessonButton_Computed: { from: "ShowEditLessonButton_Computed" },
            suggestLabel: { from: "SuggestLabel" },
            unitId: { from: "UnitId" },
            lessonId: { from: "LessonId" },
            scheduledStartTimeUnix: { from: "ScheduledStartTime" },
          }
        },
        parse: (data: TeacherScheduleClassroomResponse) => {
          $.each(data.Events, (i, classroom) => {
            const classroomAny: any = classroom;
            let bResult: boolean;
            classroomAny.SuggestionStartTimeFormatted = dateFormat(classroom.SuggestionStartTime, 'wymdhm', true);
            // showSuggestButton
            bResult = classroom.Status === 'Scheduled'
              && ((classroom.SuggestionStartTime === null && classroom.SuggestionDeclineTime !== null)
                || (classroom.SuggestionStartTime !== null && classroom.SuggestionApproveUserId !== null)
                || (classroom.SuggestionStartTime === null && classroom.SuggestionApproveUserId === null && classroom.SuggestionDeclineTime === null)
              );
            classroomAny.ShowSuggestButton_Computed = bResult;
            // showApproveButton
            bResult = classroom.Status === 'Scheduled'
              && classroom.SuggestionStartTime !== null
              && classroom.SuggestionUserId !== null
              && classroom.TeacherId !== classroom.SuggestionUserId
              && classroom.SuggestionApproveUserId === null;
            classroomAny.ShowApproveButton_Computed = bResult;
            // showStartButton
            bResult = classroom.Status === 'InProgress';
            classroomAny.ShowStartButton_Computed = bResult;
            // suggestLabel
            let suggestLabel: string | null = null;
            const hasSuggestion = classroom.Status === 'Scheduled'
              && classroom.SuggestionStartTime !== null
              && classroom.SuggestionUserId !== null;
            const wasDeclined = classroom.Status === 'Scheduled'
              && classroom.SuggestionDeclineTime !== null
              && classroom.SuggestionApproveUserId !== null
              && classroom.SuggestionStartTime === null;
            const wasDeclinedAndSuggested = classroom.Status === 'Scheduled'
              && classroom.SuggestionDeclineTime !== null
              && classroom.SuggestionApproveUserId === null
              && classroom.SuggestionStartTime !== null;
            if (hasSuggestion) {
              if (classroom.SuggestionApproveUserId === null) {
                suggestLabel = "Change time suggested: "
                  + dateFormat(classroom.SuggestionStartTime, 'wymdhm', true)
                  + ' . Wating approval.';
              }
              else {
                const newTime = dateFormat(classroom.ScheduledStartTime, 'wymdhm', true);
                const oldTime = dateFormat(classroom.SuggestionApproveOldTime, 'wymdhm', true);
                suggestLabel = `Change time approved. New time: ${newTime}. Old time: ${oldTime}`;
              }
            }
            if (wasDeclined) {
              suggestLabel = "Change time declined: "
                + dateFormat(classroom.SuggestionDeclineTime, 'wymdhm', true);
            }
            if (wasDeclinedAndSuggested) {
              suggestLabel = "Change time declined: "
                + dateFormat(classroom.SuggestionDeclineTime, 'wymdhm', true)
                + ' . Suggested new time: '
                + dateFormat(classroom.SuggestionStartTime, 'wymdhm', true);
            }
            classroomAny.SuggestLabel = suggestLabel;
            classroomAny.StartDate = moment.utc(classroom.Start).toDate();
            classroomAny.EndDateUser = moment.utc(classroom.End).toDate();
            let startDay = moment.utc(classroom.Start).toDate().getDay();
            let endDay = moment.utc(classroom.End).toDate().getDay();
            if(startDay!=endDay){
              //if lesson is between 2 days, we must set lesson end time to end of the starting day 11:59
              classroomAny.EndDate = moment.utc(moment.utc(classroom.Start).set('minute', 59)).toDate();
            }
            else{
              classroomAny.EndDate = moment.utc(classroom.End).toDate();
            }
            // showEditLessonButton
            classroomAny.ShowEditLessonButton_Computed = classroom.Status === 'Scheduled' || classroom.Status === 'InProgress';
          });
          return data;
        }
      },
    };
    (dsOptions.schema as any).timezone = self.timezone;
    var dataSource = new kendo.data.SchedulerDataSource(dsOptions);
    scheduler.setDataSource(dataSource);
    await q.delay(0);
    self.updateStartButtons();
  }

  *renderer(): ReactNodeGenerator {
    yield (
      <Helmet key="Helmet" onChangeClientState={this.setupKendoScheduler}>
        <script id="classroom-template-agenda" type="text/x-kendo-template" key="ScriptEventTemplateAgenda">
          {
            `<div class="clasroom-template-agenda">
              <p>Student: #: studentName #</p>
              <p>#: title #</p>
              <p>Status: #: status #</p>
              #if (data.suggestLabel) {#
                <p>#= suggestLabel #</p>
              #}#
              <p class="classroom-btn-group-wrapper">
                <button class="btn btn-success btn-action-marker btn-action-start animate__animated animate__flash animate__infinite animate__slower" data-action="Start" data-classroomid="#= taskId #" data-classroom-status="#= status #" data-classroom-start-unix="#= scheduledStartTimeUnix #" style="display: none;">Start</button>
                <button class="btn btn-primary btn-action-marker" data-action="Preview" data-classroomid="#= taskId #">Preview</button>
	              #if (data.showStartButton_Computed) {#
                  <button class="btn btn-primary btn-action-marker btn-action-finish" 
                    data-action="Finish" 
                    data-classroomid="#= taskId #"
                    data-classroom-start-unix="#= scheduledStartTimeUnix #"
                    data-classroom-status="#= status #">
                    Finish Lesson
                  </button>
 		            #}#
                #if (data.showEditLessonButton_Computed) {#
                  <button class="btn btn-primary btn-action-marker" data-action="EditLesson" data-classroomid="#= taskId #" data-studentlevelid="#= studentLevelId #" data-unitid="#= unitId #" data-lessonid="#= lessonId #">Change Lesson</button>
                #}#
                #if (data.showSuggestButton_Computed) {#
                  <button class="btn btn-primary btn-action-marker" data-action="SuggestTime" data-classroomid="#= taskId #">Suggest Time</button>
                #}#
                #if (data.showApproveButton_Computed) {#
                  <button class="btn btn-primary btn-action-marker" data-action="ApproveTime" data-classroomid="#= taskId #">Approve Time</button>
                  <button class="btn btn-primary btn-action-marker" data-action="DeclineTime" data-classroomid="#= taskId #">Decline</button>
                  <button class="btn btn-primary btn-action-marker" data-action="DeclineAndSuggestTime" data-classroomid="#= taskId #">Decline & Suggest time</button>
                #}#
              </p>                       
            </div>`
          }
        </script>
        <script id="classroom-template" type="text/x-kendo-template" key="ScriptEventTemplate">
          {
            `<div className="clasroom-template">
              <p>#: studentName #. #: title #</p>
            </div>`
          }
        </script>
        <script id="event-time-template" type="text/x-kendo-template">
          {
            `#= kendo.toString(start, "t") # - #= kendo.toString(endUser, "t") #
            `
          }
        </script>
      </Helmet>
    );

    yield (
      <div id={SCHEDULER_ID} key="TeacherSchedulerDiv"></div>
    );



    yield (<TeacherEditLessonModal key='TeacherEditLessonModal-Classroom' onSaveSuccess={this.editLessonSuccess} />);
  }

  render() {
    return Array.from(this.renderer());
  }

  editLessonSuccess = async () => {
    await swal.fire({ 'icon': 'success', text: 'Classroom lesson change success' });
    window.location.reload();
  }

  updateStartButtons() {
    const self = this;

    function inProgress($btn: JQuery<HTMLElement>, startTimeUnixSeconds: number, status: ClassroomStatus) {
      const btnText = 'Start';
      $btn.removeAttr('disabled')
        .removeClass('disabled')
        .removeClass('btn-outline-success')
        .addClass('animate__animated')
        .addClass('btn-success')
        .text(btnText)
        .show();
    }

    function scheduled($btn: JQuery<HTMLElement>, startTimeUnixSeconds: number, status: ClassroomStatus) {
      const btnText = 'Start in ' + gStore.serverTime.remainingTimeString(startTimeUnixSeconds);
      $btn.attr('disabled', 'disabled')
        .removeClass('animate__animated')
        .removeClass('btn-success')
        .addClass('disabled')
        .addClass('btn-outline-success')
        .text(btnText)
        .show();
    }


    $('.btn-action-start').each((x, el) => {
      const $btn = $(el);
      var dataObj = $btn.data();
      const startTimeUnixSeconds: number = parseInt(dataObj.classroomStartUnix)
        + 30; // Add 30 seconds, give a change to background task "MarkClassroomsInProgress" to set Classroom status to InProgress
      const status: ClassroomStatus = dataObj.classroomStatus;
      switch (status) {
        case 'InProgress':
          inProgress($btn, startTimeUnixSeconds, status);
          break;
        case 'Scheduled':
          const reached: boolean = gStore.serverTime.reached(startTimeUnixSeconds);
          if (reached) {
            inProgress($btn, startTimeUnixSeconds, status);
          } else {
            scheduled($btn, startTimeUnixSeconds, status);
          }
          break;
        default:
          $btn.hide();
      }
    })

    $('.btn-action-finish').each((_, el) => {
      const $btn = $(el);
      const startUnix = parseInt($btn.data('classroom-start-unix'));
      const status: string = $btn.data('classroom-status');

      if (status !== 'InProgress') {
        $btn.hide();
        return;
      }

      const secondsSinceStart = gStore.serverTime.nowMoment.unix() - startUnix;
      const timeLimitSeconds = 15 * 60; // 15 minutes

      if (secondsSinceStart < timeLimitSeconds) {
        const remainingText = gStore.serverTime.remainingTimeString(startUnix + timeLimitSeconds);
        $btn.prop('disabled', true)
            .text(`Finish in ${remainingText}`)
            .removeClass('btn-primary')
            .addClass('btn-outline-primary disabled');
      } else {
        $btn.prop('disabled', false)
            .text('Finish Lesson')
            .removeClass('btn-outline-primary disabled')
            .addClass('btn-primary');
      }
    });
  }
}

function* renderRows(store: TeacherScheduleStore): ReactNodeGenerator {
  if (store.classRooms === null)
    return;

  const classrooms = store.classRooms;
  const currentUserId = userStatusService.status.user!.Id;

  for (let classroom of classrooms) {
    const timer = store.serverTime;
    const showSuggestTimeBtn: boolean = classroom.Status === 'Scheduled';
    const showAcceptTimeBtn: boolean = classroom.SuggestionUserId !== null
      && classroom.SuggestionUserId !== currentUserId
      && classroom.Status === 'Scheduled';

    yield (
      <tr key={classroom.Id}>
        <td>
          {dateFormat(classroom.ScheduledStartTime, 'wymdhm', true)}
        </td>
        <td>
          {classroom.Student?.FirstName}-{classroom.Student?.LastName}
        </td>
        <td>
          {classroom.Lesson?.Unit?.Name}/{classroom.Lesson?.Name}
        </td>
        <td>
          {
            classroom.Status === 'InProgress' &&
            <Link className="btn btn-primary"
              to={routes.teacherClassroom(classroom.Id)}>
              Start
            </Link>
          }
          {
            (classroom.Status === 'Scheduled' && timer !== undefined) &&
            <span className="remaining">
              {timer.remainingTimeString(classroom.ScheduledStartTime)}
            </span>
          }
          {
            classroom.Status !== 'InProgress' && classroom.Status !== 'Scheduled' &&
            ClassroomStatusLabels[classroom.Status]
          }
        </td>
        <td>

        </td>
      </tr>
    );
  }
}

function* renderer(store: TeacherScheduleStore): ReactNodeGenerator {
  if (store.scheduleClassroomsState === null)
    return;
  const state = store.scheduleClassroomsState!;



  yield (<PromiseMessage key="loader-state"
    label="Loading schedule" state={state} align="right" />);

  yield (<PromiseRetry key="retry-actions"
    state={state} retry={store.load} align="right" />);

  yield (<TeacherScheduleSceneSuggestTimeModal key='TeacherScheduleSceneSuggestTimeModal' />);
  yield (<TeacherScheduleSceneDeclineTimeModal key='TeacherScheduleSceneDeclineTimeModal' />);
  yield (<TeacherScheduleSceneAcceptTimeModal key='TeacherScheduleSceneAcceptTimeModal' />);

  if (!state.isResolved)
    return;

  yield (<TeacherSchedulerKendoUI key={SCHEDULER_ID} classroomScheduleHttpState={state} />);
}

@observer
export class TeacherScheduleScene extends React.Component {
  store: TeacherScheduleStore;

  constructor(props: any) {
    super(props);
    this.store = gStore;
  }

  componentDidMount() {
    this.store.load();
  }

  componentDidUpdate() {
  }

  componentWillUnmount() {
    this.store.dispose();
  }

  render() {
    return Array.from(renderer(this.store));
  }
}



interface ClassroomSuggestTimeRequest {
  ClassRoomId: number;
  DateAndTime: string;
}

interface ClassroomAcceptTimeRequest {
  ClassRoomId: number;
}

type SuggestModalState = {
  isOpen: boolean;
}

type DeclineModalState = {
  isOpen: boolean;
}

type ApproveModalState = {
  isOpen: boolean;
}



class TeacherScheduleSceneSuggestTimeModal extends React.Component<{}, SuggestModalState> {

  private readonly disposers = new Disposers();

  constructor(props: any) {
    super(props);
    this.state = { isOpen: false };
  }

  componentDidMount() {
    this.disposers.add(reaction(() => gStore.suggestedClassRoom, () => {
      this.setState({ isOpen: gStore.suggestedClassRoom != null });
    }))
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }

  render() {
    const studentName = gStore.suggestedClassRoom?.StudentName;
    const lessonTitle = gStore.suggestedClassRoom?.Title;
    return (
      <Modal isOpen={this.state.isOpen}
        size="md"
        centered={true}
        onOpened={this.onOpened}>
        <ModalHeader>
          <div>Suggest time</div>
        </ModalHeader>
        <ModalBody>
          <p>Student: <strong>{studentName}</strong></p>
          <p>Lesson: <strong>{lessonTitle}</strong></p>
          <p><input id="suggestDatetimepicker" /></p>
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-light"
            onClick={this.onCloseClick}>
            Close
          </button>
          <button type="button" className="btn btn-primary"
            onClick={this.onSubmitClick}>
            Suggest
          </button>
        </ModalFooter>
      </Modal>
    );
  }

  onOpened = () => {
    $("#suggestDatetimepicker").kendoDateTimePicker({
      value: new Date(),
      dateInput: true
    });
  }

  onCloseClick = () => {
    gStore.suggestedClassRoom = null;
  }

  onSubmitClick = async () => {
    const classRoom = gStore.suggestedClassRoom;
    if (!classRoom) {
      return;
    }
    var datetimepicker = $("#suggestDatetimepicker").data("kendoDateTimePicker");
    let url = `${environment.apiServer}/teacher/classroom-suggest-time`;
    var momentDate = moment(datetimepicker.value());
    const request: ClassroomSuggestTimeRequest = {
      ClassRoomId: classRoom.ClassRoomId,
      DateAndTime: momentDate.format()
    }
    await httpClient.axios.postWithSweetAlert<any>(url, request);
    gStore.suggestedClassRoom = null;
    Swal.fire({ icon: 'success' });
    gStore.load();
  }
}

class TeacherScheduleSceneDeclineTimeModal extends React.Component<{}, DeclineModalState> {

  private readonly disposers = new Disposers();

  constructor(props: any) {
    super(props);
    this.state = { isOpen: false };
  }

  componentDidMount() {
    this.disposers.add(reaction(() => gStore.declinedAndSuggestedClassRoom, () => {
      this.setState({ isOpen: gStore.declinedAndSuggestedClassRoom != null });
    }))
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }

  render() {
    const teacherName = gStore.declinedAndSuggestedClassRoom?.TeacherName;
    const lessonTitle = gStore.declinedAndSuggestedClassRoom?.Title;
    return (
      <Modal isOpen={this.state.isOpen}
        size="md"
        centered={true}
        onOpened={this.onOpened}>
        <ModalHeader>
          <div>Decline & Suggest time</div>
        </ModalHeader>
        <ModalBody>
          <p>Teacher: <strong>{teacherName}</strong></p>
          <p>Lesson: <strong>{lessonTitle}</strong></p>
          <p><input id="declineSuggestDatetimepicker" /></p>
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-light"
            onClick={this.onCloseClick}>
            Close
          </button>
          <button type="button" className="btn btn-primary"
            onClick={this.onSubmitClick}>
            Decline & Suggest
          </button>
        </ModalFooter>
      </Modal>
    );
  }

  onOpened = () => {
    $("#declineSuggestDatetimepicker").kendoDateTimePicker({
      value: new Date(),
      dateInput: true
    });
  }

  onCloseClick = () => {
    gStore.declinedAndSuggestedClassRoom = null;
  }

  onSubmitClick = async () => {
    const classRoom = gStore.declinedAndSuggestedClassRoom;
    if (!classRoom) {
      return;
    }
    var datetimepicker = $("#declineSuggestDatetimepicker").data("kendoDateTimePicker");
    let url = `${environment.apiServer}/teacher/classroom-decline-suggest-time`;
    var momentDate = moment(datetimepicker.value());
    const request: ClassroomSuggestTimeRequest = {
      ClassRoomId: classRoom.ClassRoomId,
      DateAndTime: momentDate.format()
    }
    await httpClient.axios.postWithSweetAlert<any>(url, request);
    gStore.declinedAndSuggestedClassRoom = null;
    Swal.fire({ icon: 'success' });
    gStore.load();
  }
}

class TeacherScheduleSceneAcceptTimeModal extends React.Component<{}, ApproveModalState> {

  private readonly disposers = new Disposers();

  constructor(props: {}) {
    super(props);
    this.state = { isOpen: false };
  }

  componentDidMount() {
    this.disposers.add(reaction(() => gStore.acceptClassRoom, () => {
      this.setState({ isOpen: gStore.acceptClassRoom != null });
    }))
  }

  componentWillUnmount() {
    this.disposers.dispose();
  }

  render() {
    const studentName = gStore.acceptClassRoom?.StudentName;
    const lessonTitle = gStore.acceptClassRoom?.Title;
    const suggestionStartTime: number | null = gStore.acceptClassRoom?.SuggestionStartTime ?? null;
    return (
      <Modal isOpen={this.state.isOpen}
        size="md"
        centered={true}
        onOpened={this.onOpened}>
        <ModalHeader>
          <div>Accept time</div>
        </ModalHeader>
        <ModalBody>
          <p>Student: <strong>{studentName}</strong></p>
          <p>Lesson: <strong>{lessonTitle}</strong></p>
          <p>Time: <strong>{dateFormat(suggestionStartTime, 'wymdhm', true)}</strong></p>
        </ModalBody>
        <ModalFooter>
          <button type="button" className="btn btn-light"
            onClick={this.onCloseClick}>
            Close
          </button>
          <button type="button" className="btn btn-primary"
            onClick={this.onSubmitClick}>
            Accept
          </button>
        </ModalFooter>
      </Modal>
    );
  }

  onOpened = () => {

  }

  onCloseClick = () => {
    gStore.acceptClassRoom = null;
  }

  onSubmitClick = async () => {
    const classRoom = gStore.acceptClassRoom;
    if (!classRoom) {
      return;
    }
    let url = `${environment.apiServer}/teacher/classroom-approve-time`;
    const request: ClassroomAcceptTimeRequest = {
      ClassRoomId: classRoom.ClassRoomId,
    }
    await httpClient.axios.postWithSweetAlert<any>(url, request);
    gStore.acceptClassRoom = null;
    Swal.fire({ icon: 'success' });
    gStore.load();
  }
}
